import ChatTable from './ChatTable';

export default ChatTable;